<template>
    <form v-if="employee_extended && hasAccess" @submit.prevent="save" class="pt-2">
        <top-nav-bar goto="/?page=profile"></top-nav-bar>

        <div class="pb-8">
            <h4 class="mb-10 pl-4 text-lg">
                <span class="pb-2 border-b-4 border-blue">{{ trans('crewman::contact.state.contact') }}</span>
            </h4>

            <div class="flex flex-col sm:flex-row">
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="work_email" :label="trans('crewman::contact.state.primary_email')">
                        <input type="email" class="input" :value="employee_extended.work_email" disabled>
                    </form-group>
                </div>
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="private_email" :label="trans('crewman::contact.state.secondary_email')">
                        <input type="email" class="input" v-model="employee_extended.private_email">
                    </form-group>
                </div>
            </div>

            <div class="flex">
                <div class="w-1/3 pl-4 md:w-1/4 pb-0 sm:pb-4 px-1">
                    <form-group name="primary_phone_dial"
                                :label="trans('crewman::contact.state.primary_phone_number')" :required="true">
                        <v-select label="human_value" :options="human_dial_codes"
                                  :on-change="(value) => { changeDialCode(employee_extended, 'primary_phone_dial', value) }"
                                  v-model="employee_extended.primary_phone_dial"
                                  placeholder="Type to find dial code..."></v-select>
                    </form-group>
                </div>
                <div class="flex-1 pr-4 pb-0 sm:pb-4 px-1">
                    <form-group name="primary_phone_number" label="&nbsp;" :required="true">
                        <input type="text" class="input" v-model="employee_extended.primary_phone_number">
                    </form-group>
                </div>
            </div>

            <div class="flex">
                <div class="w-1/3 pl-4 md:w-1/4 pb-0 sm:pb-4 px-1">
                    <form-group name="secondary_phone_dial"
                                :label="trans('crewman::contact.state.secondary_phone_dial')">
                        <v-select label="human_value" :options="human_dial_codes"
                                  :on-change="(value) => { changeDialCode(employee_extended, 'secondary_phone_dial', value) }"
                                  v-model="employee_extended.secondary_phone_dial"
                                  placeholder="Type to find dial code..."></v-select>
                    </form-group>
                </div>
                <div class="flex-1 pr-4 pb-0 sm:pb-4 px-1">
                    <form-group name="secondary_phone_number" label="&nbsp;">
                        <input type="text" class="input" v-model="employee_extended.secondary_phone_number">
                    </form-group>
                </div>
            </div>

            <address-field name="residential_address" :label="trans('crewman::contact.state.residential_address')"

                           v-model="employee_extended.residential_address"></address-field>
            <address-field name="temporary_address" :label="trans('crewman::contact.state.temporary_address')"
                           :optional="true"
                           v-model="employee_extended.temporary_address"></address-field>

            <h4 class="mb-10 pl-4 text-lg">
                <span class="pb-2 border-b-4 border-blue">{{ trans('crewman::contact.state.postal_address') }}</span>
            </h4>

            <div class="flex">
                <div class="flex-1 px-4 pb-2">
                    <form-group :name="'postal_address_type'"
                                :label="trans('crewman::contact.state.which_address')">
                        <v-select label="label" :options="postal_address_type_list"
                                  :on-change="onChangePostalAddressType"
                                  :value="selected_postal_address_type" class="dropup"></v-select>
                    </form-group>
                </div>
            </div>

            <div class="block md:inline-flex md:float-right px-4 md:mb-10">
                <button class="btn btn--colored__green w-full" type="submit">
                    <template v-if="saving">
                        <i class="fal fa-spinner fa-spin"></i>
                        {{ trans('crewman::common.button.saving') }}
                    </template>
                    <template v-else>
                        <i class="fal fa-check"></i>
                        {{ trans('crewman::common.button.save') }}
                    </template>
                </button>
            </div>

        </div>
    </form>
</template>

<script>
import {mapState} from 'vuex'
import HandlesDialCodes from '@/mixins/HandlesDialCodes'
import NeedsCountries from '@/mixins/NeedsCountries'
import NeedsDialCodes from '@/mixins/NeedsDialCodes'
import CanAccessView from "../mixins/CanAccessView";

export default {
    mixins: [HandlesDialCodes, NeedsCountries, NeedsDialCodes, CanAccessView],

    data() {
        return {
            postal_address_type_list: [
                {value: 'residential_address', label: 'Residential Address'},
                {value: 'temporary_address', label: 'Temporary Address'},
            ],
            saving: false,
        }
    },

    computed: {
        ...mapState(['employee_extended', 'countries']),

        selected_postal_address_type() {
            if (this.employee_extended.postal_address_type !== null
                && typeof this.employee_extended.postal_address_type === 'string'
                && this.postal_address_type_list
                    .filter(item => item.value === this.employee_extended.postal_address_type).length) {
                return this.postal_address_type_list
                    .find(item => item.value === this.employee_extended.postal_address_type)
            }
            return this.employee_extended.postal_address_type;
        },

        gender: {
            get() {
                if (!this.genders.length) {
                    let gender = this.genders.find(gender => this.employee_extended.gender === gender.value)
                    if (gender) {
                        return gender.label
                    }
                    return gender.label
                }
            },
            set(value) {
                if (!value) {
                    return;
                }
                this.employee_extended.gender = value.value
            }
        },
    },

    methods: {
        onChangePostalAddressType(obj) {
            if (obj !== null && typeof obj.value !== "undefined") {
                this.employee_extended.postal_address_type = obj.value;
            }
        },

        save() {
            this.saving = true;
            let data = {
                private_email: this.employee_extended.private_email,
                primary_phone_dial: this.employee_extended.primary_phone_dial,
                primary_phone_dial_country: this.employee_extended.primary_phone_dial_country,
                primary_phone_dial_country_code: this.employee_extended.primary_phone_dial_country_code,
                primary_phone_number: this.employee_extended.primary_phone_number,
                secondary_phone_dial: this.employee_extended.secondary_phone_dial,
                secondary_phone_number: this.employee_extended.secondary_phone_number,
                secondary_phone_dial_country_code: this.employee_extended.secondary_phone_dial_country_code,
                residential_address: this.employee_extended.residential_address,
                temporary_address: this.employee_extended.temporary_address,
                postal_address_type: this.employee_extended.postal_address_type,
            };

            if (data.residential_address !== null) {
                data.residential_address.country = this.checkValue(data.residential_address.country);
            }
            if (data.temporary_address !== null) {
                data.temporary_address.country = this.checkValue(data.temporary_address.country);
            }
            if (data.postal_address_type !== null) {
                data.postal_address_type = this.checkValue(data.postal_address_type);
            }

            this.$api('hr').post('employee/contact', data)
                .then(() => {
                    this.$store.dispatch('fetchEmployeeExtended')
                    this.$noty.success('Updated contact information.')
                    this.saving = false;
                })
                .catch(() => {
                    this.saving = false;
                })
        },

        checkValue(val) {
            if (val && typeof val === 'object' && typeof val.value !== 'undefined') {
                return val.value;
            }
            return val;
        }
    },
}
</script>
